import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/table-select' },
  { path: '/table-select', component: () => import('@/views/TableSelect.vue'), meta: { title: '选择桌号' } },
  { path: '/menu', component: () => import('@/views/Menu.vue'), meta: { title: '点餐' } },
  { path: '/cart', component: () => import('@/views/Cart.vue'), meta: { title: '购物车' } },
  { path: '/order-success', component: () => import('@/views/OrderSuccess.vue'), meta: { title: '下单成功' } }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '售楼部点餐'
  next()
})

export default router
